export default __webpack_public_path__ + "static/media/bs5.1.1d9e4f01.png";